export default __webpack_public_path__ + "static/media/ans4.20314b17.png";